import React from "react";

import WarningIcon from "@uui/AlertSquare";
import StarIcon from "@uui/Star06";

import { Stack, StackProps, SxProps, Typography } from "@mui/material";

const Notice = ({
  children,
  variant,
  showIcon = true,
  icon,
  alignItems = "center",
  sx,
}: {
  children: React.ReactNode;
  variant?: "info" | "warning";
  showIcon?: boolean;
  icon?: React.ReactNode;
  alignItems?: StackProps["alignItems"];
  sx?: SxProps;
}) => {
  const isWarning = variant === "warning";
  return (
    <Stack
      sx={{
        width: "100%",
        backgroundColor: isWarning ? "shades.orange.50" : "shades.ghost.500",
        borderRadius: "12px",
        padding: "8px 12px",
        ...sx,
      }}
      direction="row"
      alignItems={alignItems}
      spacing="12px"
    >
      {showIcon &&
        !icon &&
        (isWarning ? (
          <WarningIcon sx={{ color: "shades.orange.500", width: "16px" }} />
        ) : (
          <StarIcon sx={{ color: "shades.primary.500", width: "16px" }} />
        ))}
      {showIcon && icon ? icon : null}
      <Typography
        sx={{
          color: isWarning ? "shades.orange.600" : "shades.neutral.600",
          textAlign: showIcon ? "left" : "center",
          width: "100%",
        }}
        variant="bodySecondaryMed"
      >
        {children}
      </Typography>
    </Stack>
  );
};

export default Notice;
